import type { YieldRange } from './feeImmunity.type'

function hasYieldRange(
  maxYieldValue: number | null | undefined
): maxYieldValue is number {
  return maxYieldValue != null && maxYieldValue > 0
}

export function formatYieldValue(yieldValue: number): string {
  return yieldValue.toLocaleString('sk-SK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function calculateFeeSaving(yieldValue: number, fee: number): number {
  return yieldValue * fee
}

export function toNetYield(
  grossYield: number,
  fee: number,
  hasFeeImmunity: boolean
): number {
  if (!hasFeeImmunity) return grossYield

  return grossYield * (1 - fee)
}

export function formatFeeSaving(
  yieldValue: number,
  fee: number
): string | undefined {
  if (fee === 0) return undefined

  return `+${formatYieldValue(calculateFeeSaving(yieldValue, fee))} %`
}

export function formatYieldWithImmunity({
  minYieldValue,
  maxYieldValue,
}: YieldRange): string {
  if (minYieldValue == null) return ''

  if (hasYieldRange(maxYieldValue)) {
    return `${formatYieldValue(minYieldValue)} - ${formatYieldValue(maxYieldValue)}`
  }

  return `${formatYieldValue(minYieldValue)}`
}

export function formatFeeSavingDisplay(
  minYieldValue: number,
  fee: number,
  maxYieldValue?: number
): string | undefined {
  if (fee === 0) return undefined

  if (hasYieldRange(maxYieldValue)) {
    return `${formatYieldValue(calculateFeeSaving(minYieldValue, fee))} - ${formatYieldValue(calculateFeeSaving(maxYieldValue, fee))}`
  }

  return formatYieldValue(calculateFeeSaving(minYieldValue, fee))
}
